export const SlideData = [
  {
    image:
      "https://l0dl1j3lc42iebd82042pgl2-wpengine.netdna-ssl.com/wp-content/uploads/sites/2/2021/01/solarcleano-camera-dusk-2048x1136.jpg",
    Name: "Solar Panel Cleaning",
  },
  {
    image:
      "https://solvoltaics.com/wp-content/uploads/2021/09/Cracked-Solar-Panel.jpg",
    Name: "Solar Panel Glass Break Repairing",
  },
  {
    image:
      "https://cdn.kqed.org/wp-content/uploads/sites/10/2021/12/RS29461_SOLAR_021318_348-qut-1020x681.jpg",
    Name: "Solar Panel Repairing",
  },

  {
    image:
      "https://us.sunpower.com/sites/default/files/web-version-sun-1805_4.jpg",
    Name: "Solar Panel Moving",
  },
];
